var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pepperTransformations),function(pepper){return _c('div',{key:pepper.id,staticClass:"pepper",style:('left: ' + pepper.x + 'vw; top: ' + pepper.y + 'vh; ' +
          'transform: scale('+ pepper.scale +') rotate('+ pepper.rotate +'deg) scaleX('+ pepper.scaleX +');' +
          'filter: blur(5px); z-index: -1')},[_c('LogoElement')],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }